import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
    (theme) => ({
      root: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        width: "100%",
        padding: 0,
        margin: 0,
        backgroundColor: theme.palette.background.paper,
      },
      wrapper: {
        width: "360px",
        position: "relative",
        // border: "1px solid red",
        padding: "20px !important",
        margin: "0px 20px !important",
      },
      label: {
        display: "block",
        marginBottom: "4px",
        fontSize: "0.8rem",
        cursor: "default",
        fontWeight: theme.typography.fontWeightRegular,
        color: theme.palette.grey[800],
      },
      inputWrapper: {
        paddingTop: "10px",
        width: "100%",
      },
      flexLabel: {
        display: "flex",
        alignItems: "center",
      },
      linkAction: {
        marginBottom: "4px",
        cursor: "pointer",
        fontSize: "0.8rem !important",
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.secondary.light,
      },
      titleWrapper: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
          "& a": {
              color: theme.palette.text.primary,
              textDecoration: "none"
          },
        "& span": {
          fontSize: "1.5rem",
          fontWeight: 600,
        },
        "& span.extra": {
          fontSize: ".96rem",
          fontWeight: 600,
          color: theme.palette.secondary.light,
          marginLeft: "6px",
          textTransform: "uppercase",
        },
      },
      caption: {
        color: theme.palette.grey[800],
        textAlign: "center",
        fontSize: "0.86rem !important",
        marginBottom: 40,
      },
      loginButtonWrapper: {
        position: "relative",

        "& .loader": {
          position: "absolute",
          top: 10,
          right: 16,
        },
      },
        buttonLabel: {
            fontSize: "0.88rem",
            fontWeight: theme.typography.fontWeightMedium,
        }
    }),
    { name: "icip-admin-styles", flip: null }
);

export default useStyles;
